import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class CategoryEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {name: '', code: '', updated: false};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.itemGet();
  }

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onSubmit(event) {
    event.preventDefault();
    var qId = this.props.match.params.id;
    const formData = this.state;
    fetch(process.env.REACT_APP_API_URL + '/categories/' + qId + '/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log('data', data);
      if( data._id )
        this.setState({ updated: true });
    });
  }

  itemGet() {
    var qId = this.props.match.params.id;
    fetch(process.env.REACT_APP_API_URL + '/categories/' + qId)
      .then( ( response ) => response.json() )
      .then( ( data ) => {
        this.setState({ name: data.name })
      });
  }

  render() {
    return (
      <form id="new-form" className="form container" method="POST" onSubmit={ this.onSubmit }>

        { this.state.updated && <div className="alert alert-success">Updated!</div> }

        <div className="form-group">
          <label>Category</label>
          <input name="name" className="form-control form-control-lg" value={this.state.name} onChange={ this.onChange } />
        </div>
        <div className="form-group">
          <label>Code</label>
          <input name="code" className="form-control form-control-lg" value={this.state.code} onChange={ this.onChange } />
        </div>
        <input type="submit" className="btn btn-primary" value="Update" />
        <Link to="/categories" className="btn btn-sm btn-default">Volver</Link>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/CategoryEdit.jsx